import React from "react";
import { fakeReviews } from "../../Datas/ProductDatas/reviews";
import Marquee from "react-fast-marquee";
import ReviewCard from "./ReviewCard";
// import Swiper core and required modules
import { Navigation, Pagination, Scrollbar, A11y } from "swiper";

import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";

const ReviewBottom = ({ userReviews = [] }) => {
  return (
    <div className="mb-4 shadow-lg rounded-lg p-3 bg-front dark:dark-bg-front">
      <h2 className="text-4xl font-bold mb-2 text-center ">{"User Reviews"}</h2>
      <div className="w-auto">
        <Swiper
          // install Swiper modules
          modules={[Navigation]}
          spaceBetween={50}
          // slidesPerView={4}
          navigation
          className="w-auto"
          breakpoints={{
            640: {
              slidesPerView: 1,
              spaceBetween: 20,
            },
            768: {
              slidesPerView: 2,
              spaceBetween: 40,
            },
            1024: {
              slidesPerView: 3,
              spaceBetween: 50,
            },
          }}
        >
          {userReviews.length > 0 ? (
            userReviews.map((rev) => (
              <SwiperSlide key={rev.id} className="w-auto">
                <ReviewCard rev={rev} />
              </SwiperSlide>
            ))
          ) : (
            <p>No reviews yet.</p>
          )}
        </Swiper>
      </div>
    </div>
  );
};

export default ReviewBottom;
